import React from 'react'
import PropTypes from 'prop-types'

const MicrosoftLogo = ({ size = 24, color = '#000000' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.4 11.4H2V2H11.4V11.4Z" fill="#F25022" />
      <path d="M22 11.4H12.6V2H22V11.4Z" fill="#7FBA00" />
      <path d="M11.4 22H2V12.6H11.4V22Z" fill="#00A4EF" />
      <path d="M22 22H12.6V12.6H22V22Z" fill="#FFB900" />
    </svg>
  )
}

export default MicrosoftLogo

MicrosoftLogo.propTypes = {
  size: PropTypes.number,
  color: PropTypes.array,
}
